import {Firmware} from "../firmware";

export enum StageIdentifier {
    LEGACY = "legacy",
    PROD = "prod",
    DEV = "dev",
    NO_SELECTION = "no_selection",
}

export enum StageField {
    IDENTIFIER = "identifier",
    DESCRIPTION = "description",
    DEFAULT_FIRMWARE_ID = "defaultFirmwareId",
    DEFAULT_FIRMWARE = "defaultFirmware",
    LOCKED = "locked",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
}

export interface Stage {
    [StageField.IDENTIFIER]: StageIdentifier;
    [StageField.DESCRIPTION]: string;
    [StageField.DEFAULT_FIRMWARE]?: Firmware;
}

export interface OrganizationStage extends Stage {
    [StageField.LOCKED]: string;
    [StageField.CREATED_AT]: string;
    [StageField.UPDATED_AT]: string;
}

export type StageDefaultFirmwareForm = {
    [key in StageIdentifier]?: number;
};
